// API service for farmacos management
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class FarmacoService {
  static async getAllFarmacos(token) {
    const response = await fetch(`${API_BASE_URL}/farmacos`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async createFarmaco(data, token) {
    const response = await fetch(`${API_BASE_URL}/farmacos`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async updateFarmaco(id, data, token) {
    const response = await fetch(`${API_BASE_URL}/farmacos/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async deleteFarmaco(id, token) {
    const response = await fetch(`${API_BASE_URL}/farmacos/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }

  static async searchFarmacos(query, token) {
    const response = await fetch(`${API_BASE_URL}/farmacos/search?query=${encodeURIComponent(query)}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  }
}

export default FarmacoService;
